<div
  [@fadeInOut]="{ value: 'in', params: { time: '1.5s' } }"
  class="d-flex flex-row custom-snack-bar"
  [ngStyle]="{ backgroundColor: data.backgroundColor }"
>
  <img [src]="data.iconUrl" alt="Icon" />
  <span class="text">{{ data.message }}</span>
</div>
